"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultContactiveHeaders_1 = require("../../getDefaultContactiveHeaders");
var http_client_1 = require("@fuze/apis-core/dist/http-client");
/**
 * Given a userKey, password, option id, and token type, attempt to authenticate the user with warden
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param organizationCode The organization code that all of the users must belong to
 * @param userIds A list of numeric warden user ids (note that they are strings)
 */
function getContacts(baseUrl, wardenToken, organizationCode, userIds) {
    var serializedUserIds = userIds.map(function (userId) { return "ngchat:user_" + userId; }).join(",");
    return http_client_1.default({
        method: "GET",
        url: baseUrl + "/organizations/" + organizationCode + "/directory/contacts/chats/" + serializedUserIds,
        headers: getDefaultContactiveHeaders_1.default(wardenToken)
    }).then(function (response) { return response.data; });
}
exports.default = getContacts;
